// extracted by mini-css-extract-plugin
export var burger = "headerWithNav-module--burger--47ed6";
export var burgerIsOpened = "headerWithNav-module--burger--is-opened--e34f8";
export var burgerLine = "headerWithNav-module--burger-line--76034";
export var headerNav = "headerWithNav-module--header-nav--5c087";
export var headerNav__btn = "headerWithNav-module--header-nav__btn--0f033";
export var headerNav__fixed = "headerWithNav-module--header-nav__fixed--1459a";
export var headerNav__left = "headerWithNav-module--header-nav__left--e7320";
export var headerNav__list = "headerWithNav-module--header-nav__list--71900";
export var headerNav__listItem = "headerWithNav-module--header-nav__list--item--f5c63";
export var headerNav__listLink = "headerWithNav-module--header-nav__list--link--bf79e";
export var headerNav__logo = "headerWithNav-module--header-nav__logo--4e690";
export var headerNav__logoImg = "headerWithNav-module--header-nav__logo--img--87927";
export var headerNav__nav = "headerWithNav-module--header-nav__nav--0886b";
export var headerNav__navIsClosed = "headerWithNav-module--header-nav__nav--is-closed--ab622";
export var headerNav__navIsOpened = "headerWithNav-module--header-nav__nav--is-opened--28369";
export var headerNav__tel = "headerWithNav-module--header-nav__tel--708a3";
export var headerNav__wrapper = "headerWithNav-module--header-nav__wrapper--3522a";
export var navClose = "headerWithNav-module--nav-close--83af1";
export var navOpen = "headerWithNav-module--nav-open--3d5cc";